import "./index.scss";
import countryImg from "../../assets/images/point_map.png";
import AppStoreImg from "../../assets/images/buttons/appstore_whiteBorder.svg";
import PreorderImg from "../../assets/images/buttons/preorder.svg";

import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  setOpenedModal,
  setOpenedModalStart,
  changeConditionShown,
} from "../../redux/actions";
import uid from "uid";
import animation from "../../animation";
import { pageLoad } from "../../functions/route";

const Footer = ({
  setOpenedModal,
  setOpenedModalStart,
  changeConditionShown,
}) => {
  useEffect(() => {
    const wholePath = window.location.pathname;
    const pathname = wholePath ? wholePath.replace(/\//g, '') : "";

    switch (pathname) {
      case "contactus":
        openModal(false, "contactus");
        break;
      case "support":
        openModal(false, "appSupport");
        break;
      case "artup-support":
        openModal(false, "appSupportArt");
        break;
      default:
        break;
    }
  }, []);

  const topItems = [
    {
      title: "MA ArtUp",
      titleP1: "MA",
      titleP2: "ArtUp",
      subTitle: "iPhone",
      type: "gallery",
      period: null,
      link: 'https://apps.apple.com/us/app/artup-portfolio-staging/id6444745430',
    },
    {
      title: "MA Gallery",
      titleP1: "MA",
      titleP2: "Gallery",
      subTitle: "iPad",
      type: "gallery",
      period: null,
      link: 'https://apps.apple.com/us/app/ma-gallery-ai-powered-art-crm/id1599151137',
    },
    {
      title: "MA Gallery",
      titleP1: "MA",
      titleP2: "Gallery",
      subTitle: "Mac",
      type: "gallery",
      period: "dec 2023",
      link: 'https://www.apple.com/app-store/',
    },
    // {
    //   title: "MA Match",
    //   type: "match",
    //   period: 1,
    // },
    // {
    //   title: "MA Proof",
    //   type: "proof",
    //   period: 2,
    // },
  ];

  const openModal = (e, type) => {
    const urlChangeType =
      type === "contactus" ? "contactus" : type === "appSupport" ? "support" : "";

    if (urlChangeType) {
      pageLoad(urlChangeType);
      setOpenedModalStart(type);
    }
    setOpenedModal(type);
  };

  const openConditions = (e, type) => {
    e.preventDefault();
    changeConditionShown(type);
    animation.openPrivacy();
  };

  return (
    <div className={`footer`}>
      <div className={`footer-top`}>
        {topItems.map((item) => (
          <ul key={uid()} className={`footer-top__list`}>
            {item.period ? (
              <>
                <li className={`footer-top__item`}>{item.titleP1}<span>/</span>{item.titleP2}</li>
                <li className={`footer-top__item`}><span>for</span> {item.subTitle}</li>
                <li className={`footer-top__item footer-top__item-images`}>
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={PreorderImg}
                      alt="Pre-order"
                      className={`footer__image-gallery`}
                    />
                  </a>
                </li>   
                <li className={`footer-top__item`}>Coming {item.period}</li>             
              </>
            ) : (
              <>
                <li className={`footer-top__item`}>{item.titleP1}<span>/</span>{item.titleP2}</li>
                <li className={`footer-top__item`}><span>for</span> {item.subTitle}</li>
                <li className={`footer-top__item footer-top__item-images`}>
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={AppStoreImg}
                      alt="App Store"
                      className={`footer__image-gallery`}
                    />
                  </a>
                </li>
              </>
            )}
          </ul>
        ))}
        <div className={`footer-top__title`}>Down loads</div>
      </div>
      <div className={`footer-bottom`}>
        <div
          className={`footer-address`}
          style={{ backgroundImage: `url(${countryImg})` }}
        >
          <p className={`footer-address__text`}>
            91 Wimpole Street, 
            <br />London W1G 0EF, 
            <br />United Kingdom
          </p>
        </div>
        <div className={`footer-contacts`}>
          {/* <div className={`footer-contacts__top`}>
            <a
              href="tel:44-20-3322-3335"
              className={`footer-contacts__phone footer-contacts__phone-reset`}
            >
              <span
                className={`footer-contacts__phone-number footer-contacts__phone-reset`}
              >
                +44 20 3322 3335
              </span>
              <span
                className={`footer-contacts__phone-underline footer-contacts__phone-reset`}
              />
            </a>
            <br />
            <span
              onClick={(e) => openModal(e, "contactus")}
              className={`footer__link footer-contacts__phrase`}
            >
              contact us
            </span>
            <br />
            <span
              href="#"
              onClick={(e) => openModal(e, "appSupport")}
              className={`footer__link footer-contacts__phrase`}
            >
              app support
            </span>
          </div> */}
          <div className={`footer-contacts__links`}>
            <ul className={`footer-contacts__list`}>
              <li className={`footer-contacts__item`}>
                <span
                  onClick={(e) => openModal(e, "contactus")}
                  className={`footer__link`}
                >
                  contact us
                </span>
              </li>
              <li className={`footer-contacts__item`}>
                <span
                  href="#"
                  onClick={(e) => openModal(e, "appSupport")}
                  className={`footer__link`}
                >
                  support
                </span>
              </li>
              {/* <li className={`footer-contacts__item`}>
                <a
                  className={`footer__link`}
                  href="https://www.facebook.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  facebook
                </a>
              </li>
              <li className={`footer-contacts__item`}>
                <a
                  className={`footer__link`}
                  href="https://www.instagram.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  instagram
                </a>
              </li>
              <li className={`footer-contacts__item`}>
                <a
                  className={`footer__link`}
                  href="https://www.linkedin.com/feed/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  linkedIn
                </a>
              </li> */}
            </ul>
            <ul className={`footer-contacts__list`}>
              <li className={`footer-contacts__item`}>
                <a
                  className={`footer__link`}
                  href="/terms-of-service"
                  target="_blank"
                  // rel="noopener noreferrer"
                  // onClick={(e) => openConditions(e, "terms")}
                  // style={{ pointerEvents: "none" }}
                >
                  Terms &amp; Conditions
                </a>
              </li>
              <li className={`footer-contacts__item`}>
                <a
                  className={`footer__link`}
                  href="/privacy-notice"
                  target="_blank"
                  // rel="noopener noreferrer"
                  // onClick={(e) => openConditions(e, "privacy")}
                  // style={{ pointerEvents: "none" }}
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
          <p className={`footer-contacts__copy`}>
            &copy; 2022-2024 Art eService Ltd. 
            <br />ArtUp, MA/ArtUp, MA/Gallery are trademarks of Art eService Ltd. 
            <br />Registered in England. Company Number 12442182. 
            <br />All rights reserved.
          </p>
        </div>
      </div>
      <p className={`new`}></p>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setOpenedModalStart: (value) => dispatch(setOpenedModalStart(value)),
  setOpenedModal: (value) => dispatch(setOpenedModal(value)),
  changeConditionShown: (value) => dispatch(changeConditionShown(value)),
});

export default connect(null, mapDispatchToProps)(Footer);
